import { z } from 'zod';

export const ViewerDisplayMode = z.enum([
  'NORMAL',
  'FULLSCREEN',
  'PRINT'
]);
export type ViewerDisplayMode = z.infer<typeof ViewerDisplayMode>;

export enum ViewerPrintMode {
  PRINT_AUTHOR = 'PRINT_AUTHOR',
  PRINT_USER = 'PRINT_USER'
}
